import React, { useEffect, useState } from "react";
import { Modal } from "bootstrap";
import BotaoSuporte from "../../components/BotaoSuporte.jsx";
import EditRastreamento from "../../rastreamento/editrastreamento.jsx";
import ConvocacaoTable from "../components/ConvocacaoTable";
import ExportButton from "../components/ExportButton";
import SeguimentoCategorias from "../components/SeguimentoCategorias";
import StatusCards from "../components/StatusCards";
import useConvocacaoSeguimento from "../hooks/useConvocacaoSeguimento";
import "../styles/convocacao.css";

const ConvocacaoSeguimento = () => {
    const [pacienteSelecionado, setPacienteSelecionado] = useState(null);
    const {
        filtros,
        loading,
        statusCards,
        categorias,
        updateFilter,
        rows,
        total,
        page,
        pageSize,
        selectedIds,
        clearSelection,
        allPageSelected,
        toggleSelectRow,
        toggleSelectPage,
        changePage,
        changePageSize,
        convocarPaciente,
        convocarSelecionadas,
        exportarCsv,
    } = useConvocacaoSeguimento();

    useEffect(() => {
        if (!pacienteSelecionado) return;

        const modalElement = document.getElementById("edit-rastreamento");
        if (modalElement) new Modal(modalElement).show();
    }, [pacienteSelecionado]);

    const visualizarHistorico = (row) => {
        setPacienteSelecionado({
            id: row.pessoaId,
            nome: row.nome,
            cpf: row.cpf,
        });
    };

    const categoriaLabel = {
        BIRADS_3: "Repetição de mamografia",
        ULTRASSON: "Ultrassom",
        MASTOLOGISTA: "Encaminhamento ao mastologista",
        BIOPSIA: "Biópsia em atraso",
        ALTERADOS: "Resultados alterados",
        INSATISFATORIO: "Resultado insatisfatório",
        COLPOSCOPIA: "Colposcopia",
        TRATAMENTO: "Tratamento",
    }[filtros.prioridade];

    const subtituloTabela = categoriaLabel
        ? `Convocações pendentes para ${categoriaLabel}`
        : "Convocações pendentes por resultado alterado";

    return (
        <div className="page-wrapper">
            <BotaoSuporte />
            <div className="content">
                <div className="page-header">
                    <div className="page-title">
                        <h4>Busca Ativa de Pacientes com Exames Insatisfatórios ou Resultados Alterados</h4>
                        <h6>Acompanhamento de seguimento para casos com alteração clínica.</h6>
                    </div>
                </div>

                <SeguimentoCategorias
                    categorias={categorias}
                    onCategoryChange={(categoria) =>
                        updateFilter({ prioridade: categoria || "TODAS" })
                    }
                />

                <StatusCards items={statusCards} />

                <div className="d-flex flex-column flex-md-row gap-2 justify-content-between align-items-md-center mb-3">
                    <div className="text-muted small">
                        Selecionadas: {selectedIds.length}
                    </div>
                    <button
                        className="btn btn-primary"
                        type="button"
                        onClick={convocarSelecionadas}
                        disabled={selectedIds.length === 0 || loading}
                    >
                        <i className="feather-send me-2" />
                        Convocar selecionadas
                    </button>
                </div>

                <ConvocacaoTable
                    title="Pacientes para seguimento"
                    subtitle={subtituloTabela}
                    headerAction={<ExportButton onClick={exportarCsv} />}
                    rows={rows}
                    loading={loading}
                    total={total}
                    selectedIds={selectedIds}
                    selectedCount={selectedIds.length}
                    onClearSelection={clearSelection}
                    allPageSelected={allPageSelected}
                    onTogglePage={toggleSelectPage}
                    onToggleRow={toggleSelectRow}
                    showPrioridade
                    page={page}
                    pageSize={pageSize}
                    onPageChange={changePage}
                    onPageSizeChange={changePageSize}
                    onConvocarRow={convocarPaciente}
                    onViewHistory={visualizarHistorico}
                />
            </div>
            <EditRastreamento
                pacienteSelecionado={pacienteSelecionado}
                onClose={() => setPacienteSelecionado(null)}
            />
        </div>
    );
};

export default ConvocacaoSeguimento;